// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"_1bm6j"};